import { Grid2 as Grid } from '@mui/material'
import { useState } from 'react'
import VitalsCard from '../../../components/VitalsCard'
import ProfileSelectionCard from '../../../components/ProfileSelectionCard'

function Health() {
  // eslint-disable-next-line
  const [personVitals, setPersonVitals] = useState([
    {
      name: 'Temperature',
      value: '98',
      unit: '°',
      note: 'Normal Temperature',
    },
    {
      name: 'Heart Rate',
      value: '102',
      unit: 'bpm',
      note: 'Higher Than Normal',
    },
    {
      name: 'Glucose Level',
      value: '130',
      unit: 'mg/dL',
      note: 'Higher Than Normal',
    },
    {
      name: 'Blood Pressure',
      value: '120/80',
      unit: 'mmHg',
      note: 'Normal Blood Pressure',
    },
    {
      name: 'Respiration Rate',
      value: '20',
      unit: 'breaths/min',
      note: 'Higher Than Normal',
    },
    {
      name: 'Oxygen Saturation',
      value: '100',
      unit: '%',
      note: 'Very Healthy',
    },
  ])
  const profile = [0, 1, 2]

  return (
    <Grid container direction={'column'} spacing={1.5}>
      <Grid container direction={'row'} spacing={1.5}>
        {profile?.map((item, index) => {
          return (
            <Grid size={{ xs: 12, sm: 12, lg: 2, md: 2, xl: 2 }} key={index}>
              <ProfileSelectionCard
                name={'Vinod Gadde'}
                role={'Father'}
                age={29}
                avatarSrc={'https://i.pravatar.cc/150?img=3'}
                selected={index === 0 ? true : false}
                onClick={() => {
                  console.log(1)
                }}
              />
            </Grid>
          )
        })}
      </Grid>
      <Grid container direction={'row'} spacing={1.5}>
        {personVitals?.map((item, index) => {
          return (
            <Grid size={{ xs: 12, sm: 12, lg: 3, md: 3, xl: 3 }} key={index}>
              <VitalsCard
                name={item?.name}
                value={item?.value}
                unit={item?.unit}
                note={item?.note}
              />
            </Grid>
          )
        })}
      </Grid>
    </Grid>
  )
}

export default Health
